export const ukPostcodeRegex = /^([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i;
export const ukPostcodeSearchRegex = /([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})/i;

export const usPostcodeRegex = /^\d{5}(?:-\d{4})?$/;
export const usPostcodeSearchRegex = /\d{5}(?:-\d{4})?/;
